// src/pages/Concierge/ConciergeUpper.jsx
import React from "react";

// ✅ 실제 프로젝트 경로에 맞춰 수정해서 임포트하세요.
import HeroImg1 from "../../../../assets/image/concierge/ConciergeUpperImage1.svg";
import HeroImg2 from "../../../../assets/image/concierge/ConciergeUpperImage2.svg";
import IcRocket from "../../../../assets/image/concierge/icon/icon_1.svg";
import IcWand from "../../../../assets/image/concierge/icon/icon_2.svg";
import IcCamera from "../../../../assets/image/concierge/icon/icon_3.svg";
import IcReport from "../../../../assets/image/concierge/icon/icon_4.svg";

/**
 * ConciergeUpper
 * - 업로드한 참고 이미지 레이아웃을 그대로 재현
 * - 컬러는 colorSystem.css의 CSS 변수 사용 가능 (예: var(--coolgrey-500))
 */
export default function ConciergeUpper() {
    return (
        <section className="w-full">
            <div>

                
            </div>









            {/* 상단 타이틀 영역 */}
            <div className="mx-auto w-full max-w-[1080px] px-6 pt-10 md:pt-16">
                <h2 className="text-[26px] md:text-[32px] font-extrabold leading-tight text-black">
                    컨시어지가 무엇인가요?
                </h2>
                <p className="mt-3 text-[15px] md:text-[16px] leading-[1.7] text-[var(--coolgrey-600,#47526B)]">
                    컨시어지란? 마케터를 대신해주는 대행 서비스 입니다.
                    <br className="hidden md:block" />
                    직접 이미지를 만들고 SNS로 업로드할 필요 없이 이미지 생성, SNS 업로드, 마케팅 분석까지 대신 진행해드립니다.
                </p>
            </div>

            {/* 1행: 좌측 이미지 / 우측 포인트 2개 */}
            <div className="mx-auto mt-8 md:mt-12 w-full max-w-[1080px] px-6">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
                    {/* 좌: 이미지 */}
                    <div className="md:col-span-7">
                        <div className="rounded-[20px] overflow-hidden bg-[var(--coolgrey-25,#F5F6F9)]">
                            <img
                                src={HeroImg1}
                                alt="대시보드와 모바일 연동"
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>

                    {/* 우: 포인트 2개 */}
                    <div className="md:col-span-5 flex flex-col gap-6">
                        <FeatureCard
                            icon={IcRocket}
                            title="앱 설치 없이 시작"
                            desc="브라우저에서 신청만 하면 바로 진행돼요. 필요하면 나중에 앱을 설치해 직접 관리할 수도 있어요."
                            tint="#EDE8FF"
                        />
                        <FeatureCard
                            icon={IcWand}
                            title="AI 기반 맞춤 콘텐츠"
                            desc="올린 메뉴·사진을 AI가 분석해 글·이미지를 자동 제작해요. 업종·지역·고객층에 맞춰 해시태그와 톤까지 추천해 드려요."
                            tint="#E8F2FF"
                        />
                    </div>
                </div>
            </div>

            {/* 2행: 좌측 포인트 2개 / 우측 이미지 */}
            <div className="mx-auto mt-10 md:mt-16 w-full max-w-[1080px] px-6 pb-14 md:pb-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
                    {/* 좌: 포인트 2개 */}
                    <div className="md:col-span-6 flex flex-col gap-6">
                        <FeatureCard
                            icon={IcCamera}
                            title="SNS 채널 생성/연동 대행"
                            desc="SNS 채널을 공식 위임 동의로 안전하게 연결해요. 계정이 없으면 사장님 명의로 개설까지 도와드립니다."
                            tint="#EEE9FF"
                        />
                        <FeatureCard
                            icon={IcReport}
                            title="마케팅 분석 리포트 발송"
                            desc="게시 수·반응·도달 등 핵심 지표를 한눈에 요약해 드려요. 카카오톡으로 정기 리포트를 보내드려 확인이 쉬워요."
                            tint="#EAF2FF"
                        />
                    </div>

                    {/* 우: 이미지 */}
                    <div className="md:col-span-6">
                        <div className="rounded-[20px] overflow-hidden bg-[var(--coolgrey-25,#F5F6F9)]">
                            <img
                                src={HeroImg2}
                                alt="소셜 채널과 소통"
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

/** 작은 아이콘+텍스트 카드 (오른쪽 설명 블록) */
function FeatureCard({ icon, title, desc, tint = "#EEE" }) {
    return (
        <div className="flex items-start gap-4">
            <div
                className="w-[36px] h-[36px] rounded-[10px] flex items-center justify-center shrink-0"
                style={{ background: tint }}
            >
                <img src={icon} alt="" className="w-5 h-5" />
            </div>
            <div className="flex-1">
                <p className="text-[16px] md:text-[18px] font-semibold text-[var(--ink-strong,#101828)]">
                    {title}
                </p>
                <p className="mt-1 text-[14px] md:text-[15px] leading-[1.7] text-[var(--coolgrey-600,#47526B)]">
                    {desc}
                </p>
            </div>
        </div>
    );
}
